module.exports = __webpack_public_path__ + "media/src/images/female_speaker_bg-e5252f3b86daf59e33591cd20b398d3f.jpg";